module.exports = __webpack_public_path__ + "images/location-icon.e11ce001fd31dcf030fa67cdc3fa263a.png";